export const provisioningHostname = (slug: string, environment?: string): string => {
  if (environment === 'local') return `${slug}.localhost`;
  if (environment === 'production') return `${slug}.scheduify.com`;
  return `${slug}.staging.scheduify.com`;
};

export const localTenantPublicUrl = (hostname: string): string =>
  `http://${hostname}:5002`;
